import React, { useCallback, useState } from 'react';
import { Spacer, View } from '@amzn/stencil-react-components/layout';

import { Input, InputWrapper } from '@amzn/stencil-react-components/input';
import {
  MAX_ALLOWED_DESCRIPTION_LENGTH,
  MAX_ALLOWED_NAME_LENGTH,
} from '../../enums/schedulingConstant';
import { useDispatch } from 'react-redux';
import { updateMultiCampaignDetail } from '../../actions/journeyDetailsAction';
import { useIntl } from 'react-intl';

const JourneyDetailsForm = ({ data, readonly }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { journeyName, journeyDescription } = data;

  const onNameChange = e => {
    dispatch(
      updateMultiCampaignDetail({
        ...data,
        journeyName: e.target.value,
      }),
    );
  };

  const onDescriptionChange = e => {
    dispatch(
      updateMultiCampaignDetail({
        ...data,
        journeyDescription: e.target.value,
      }),
    );
  };

  return (
    <>
      <View width="50%">
        <InputWrapper
          labelText={formatMessage({ id: 'app.groupCampaign.createMultiCampaign' })}
          fontSize={'T400'}
          id="campaign-name-wrapper"
          error={false}
          footer={formatMessage({ id: 'app.groupCampaign.createMultiCampaign' })}
        >
          {inputProps => (
            <Input
              {...inputProps}
              data-testid="journey-name-input"
              error={false}
              maxLength={MAX_ALLOWED_NAME_LENGTH}
              value={journeyName}
              disabled={readonly}
              onChange={e => onNameChange(e)}
            />
          )}
        </InputWrapper>
      </View>
      <Spacer width={20} />
      <View width="50%">
        <InputWrapper
          labelText={formatMessage({ id: 'app.groupCampaign.createMultiCampaignDescription' })}
          id="journey-description-wrapper"
          error={false}
          footer={formatMessage({ id: 'app.groupCampaign.createMultiCampaignDescription' })}
        >
          {inputProps => (
            <Input
              {...inputProps}
              data-testid="journey-description-input"
              error={false}
              value={journeyDescription}
              disabled={readonly}
              maxLength={MAX_ALLOWED_DESCRIPTION_LENGTH}
              onChange={e => onDescriptionChange(e)}
            />
          )}
        </InputWrapper>
      </View>
    </>
  );
};

export default JourneyDetailsForm;
